import React, { useEffect } from 'react'
import { hot } from 'react-hot-loader/root'
import RemoteApp from '../../utils/RemoteAppWrapper'

const addGlobalStyles = () => {
  const css = `
    html, body { overflow: auto }

    #contentTd { height: auto !important }

    #footer { display: none !important }

    .wb-tooltip { display: none !important }

    #mySidenasSingleEdit { display: none !important }
  `
  const head = document.head || document.getElementsByTagName('head')[0]
  const style = document.createElement('style')

  head.appendChild(style)

  style.id = 'timeline-styles'

  style.appendChild(document.createTextNode(css))
}

const removeGlobalStyles = () => {
  document.getElementById('timeline-styles').remove()
}

const TimelineApp = ({
  externalData,
}) => {
  useEffect(() => {
    addGlobalStyles()

    return () => {
      removeGlobalStyles()
    }
  }, [])

  const wsHeaderGap = 167; // WorkStream's page headline area height
  let teamHeaderGap = 164; // Team's page headline area height

  // Increases the Team's page headline area height with the collapsed Brief component height
  if (window.wbConfig.teamSummaryGenAiEnabled) {
    teamHeaderGap += 78;
  }

  const appHeaderGap = externalData.queryParams?.teamIds ? teamHeaderGap : wsHeaderGap
  const location = externalData.queryParams?.teamIds ? 'TEAM_PAGE' : 'WORKSTREAM_PAGE'

  return (
    <RemoteApp
      data={{
        scope: 'WorkstreamsUI',
        module: './TimelineApp',
        externalData: {
          ...externalData,
          analytics: {
            trackEvent: window.wb_track,
            eventProperties: { location, subLocation: 'TIMELINE_TAB' },
          },
          // Page and app headers gaps
          verticalGap: 65 + appHeaderGap,
        },
      }}
    />
  )
}

export default hot(TimelineApp);
